import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { getDataFetchingClientRequestState } from '../../dataFetchingClient/utils/getDataFetchingClientRequestState';
export function useCollectionItems(query, fieldName, {
  appContext,
  collectionId = 0,
  language,
  length,
  offset,
  skip
}) {
  const {
    data,
    previousData,
    error,
    loading
  } = useQuery(query, {
    skip: skip || !collectionId,
    variables: {
      appContext,
      collectionId,
      language,
      length,
      offset
    }
  });
  const requestState = getDataFetchingClientRequestState(error, loading, !!data);
  const collectionOfferingIds = useMemo(() => {
    var _ref, _collectionItems$offe;
    const collectionItems = (_ref = data !== null && data !== void 0 ? data : previousData) === null || _ref === void 0 ? void 0 : _ref[fieldName];
    return (_collectionItems$offe = collectionItems === null || collectionItems === void 0 ? void 0 : collectionItems.offeringIds) !== null && _collectionItems$offe !== void 0 ? _collectionItems$offe : [];
  }, [data, fieldName, previousData]);
  return {
    offeringIds: collectionOfferingIds,
    requestState: requestState
  };
}